import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import resource from "./blog.module.css";
import { FaArrowRightLong } from "react-icons/fa6";
import { getUserblogs, getblogCategories } from "../../../Services/APIrequests";
import parse from "html-react-parser";
import defaultIMG from "../../../Assets/defaultimg.png";
import { RotatingLines } from "react-loader-spinner";

function BlogBoxces() {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [categories, setCategories] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState(0);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBlogsAndCategories = async () => {
            try {
                // Fetch blogs
                const blogsResponse = await getUserblogs();
                const blogsData = blogsResponse.data.blogs || [];
                setBlogs(blogsData);

                // Fetch categories
                const categoriesResponse = await getblogCategories();
                const categoriesData = categoriesResponse.data.categories || [];

                // Add default "All" option
                const allCategories = [
                    { categoryId: 0, categoryName: "All" },
                    ...categoriesData,
                ];
                setCategories(allCategories);

                setError(null);
            } catch (err) {
                console.error("Error fetching data:", err);
                setError(
                    "Failed to load blogs or categories. Please try again later."
                );
                setBlogs([]);
                setCategories([]);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogsAndCategories();
    }, []);

    // Handle category selection
    const handleCategoryChange = (e) => {
        setSelectedCategoryId(parseInt(e.target.value, 10));
    };

    // Filter blogs by category
    const filteredBlogs =
        selectedCategoryId === 0
            ? blogs
            : blogs.filter((blog) => blog.categoryId === selectedCategoryId);

    // Navigate to blog details
    const handleClick = (blogId) => {
        navigate(`/blog/${blogId}`);
    };

    return (
        <div className={resource.Blogcards_container}>
            {/* Category Filter */}
            <div className={resource.Blogcards_container_filter}>
                <label
                    htmlFor="categoryDropdown"
                    className={resource.filterLabel}>
                    Filter by Category:
                </label>
                <select
                    id="categoryDropdown"
                    onChange={handleCategoryChange}
                    value={selectedCategoryId}
                    className={resource.categoryDropdown}>
                    {categories.map((category) => (
                        <option
                            key={category.categoryId}
                            value={category.categoryId}>
                            {category.categoryName}
                        </option>
                    ))}
                </select>
            </div>

            {/* Blog Cards */}
            <div className={resource.Blogcontainer_filters_cards}>
                <div className={resource.Resourceboxces_container}>
                    {loading ? (
                        <p className={resource.loadingText}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100vh",
                                }}>
                                <RotatingLines
                                    height="80"
                                    width="80"
                                    color="#4fa94d"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                />
                            </div>
                        </p>
                    ) : error ? (
                        <p className={resource.errorText}>{error}</p>
                    ) : (
                        <div className={resource.cardsubcontainer}>
                            {filteredBlogs.length > 0 ? (
                                filteredBlogs.map((blog) => (
                                    <div
                                        key={blog.blogId}
                                        className={resource.resourceBox}
                                        data-aos="fade-down"
                                        data-aos-easing="linear"
                                        data-aos-duration="1500"
                                        onClick={() =>
                                            handleClick(blog.blogSlug)
                                        }>
                                        <div
                                            className={resource.imagecontainer}>
                                            <img
                                                src={blog.image_url}
                                                onError={({
                                                    currentTarget,
                                                }) => {
                                                    currentTarget.onerror =
                                                        null;
                                                    currentTarget.src =
                                                        defaultIMG;
                                                }}
                                                alt={blog.title || "Blog Image"}
                                                className={resource.rbox_img}
                                            />
                                        </div>
                                        <div
                                            className={
                                                resource.boxheader_container
                                            }>
                                            <h1 className={resource.boxheader}>
                                                {blog.title}
                                            </h1>
                                            {/* <p className={resource.boxptext}>{blog.shortDescription}</p> */}
                                            <p className={resource.boxptext}>
                                                {parse(
                                                    blog.shortDescription || ""
                                                )}
                                            </p>
                                        </div>

                                        <div
                                            className={resource.boxbtncontainer}
                                            onClick={() =>
                                                handleClick(blog.blogSlug)
                                            }>
                                            <p className={resource.readtext}>
                                                Read More
                                            </p>
                                            <button
                                                type="button"
                                                className={resource.btn}
                                                onClick={() =>
                                                    handleClick(blog.blogSlug)
                                                }>
                                                <FaArrowRightLong size={15} />
                                            </button>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className={resource.noBlogsText}>
                                    No blogs available in this category.
                                </p>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default BlogBoxces;
